<template>
  <modal
    id="zipcodeAddress"
    name="zipcodeAddress"
    role="dialog"
    aria-labelledby="dialog-title"
    aria-describedby="dialog-content"
    class="m-full"
    :width="700"
    :height="740"
    :maxHeight="740"
    @before-close="beforeClose"
  >
    <div class="dialog__inner">
      <div class="popup-header">
        <h1 id="dialog-title" tabindex="0">주소찾기</h1>
        <button
          type="button"
          class="btn_popup_close"
          data-dismiss="modal"
          title="팝업닫기"
          @click="closeDialog"
        >
          <span>팝업 닫기</span>
        </button>
      </div>

      <div id="dialog-content" class="dialog__content">
        <div class="section">
          <div class="section-header blind">
            <h3>주소검색</h3>
          </div>
          <div class="section-body">
            <ul class="notice-text-list">
              <li class="notice-text">
                도로명 + 건물번호 <em class="primary-text">예) 한강대로32</em>
              </li>
              <li class="notice-text">
                동/읍/면/리 + 번지
                <em class="primary-text">예) 한강로3가 65-228</em>
              </li>
              <li class="notice-text">
                건물명, 아파트명 <em class="primary-text">예) 엘지유플러스</em>
              </li>
            </ul>
            <div>
              <div class="field-control-sub">
                <div class="input-wrap">
                  <input
                    v-model="inAddr"
                    type="text"
                    @input="onlyText"
                    name="inAddr"
                    class="input-text input-font input-width-xlarge"
                    placeholder="도로명주소, 건물명 또는 지번 입력"
                    title="도로명주소, 건물명 또는 지번 입력"
                  />
                  <button @click="searchAddress" type="button">검색</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="section">
          <div class="section-header blind">
            <h3>검색결과 목록</h3>
          </div>
          <div class="section-body">
            <!---검색결과가 없을 경우 노출--->
            <div v-if="addrList.length === 0">
              <p class="list-summary no-result">
                검색결과가 존재하지 않습니다.
              </p>
            </div>
            <!--- -->

            <div v-if="addrList.length !== 0">
              <p class="list-summary">
                검색결과 총
                <span class="primary-text">{{ addrList.length }}</span> 건
                입니다.
              </p>
              <ul class="list-block-type" tabindex="-1">
                <li
                  v-for="(addr, index) in displayedAddrList"
                  v-bind:key="index"
                >
                  <a
                    @click="selectAddr(addr)"
                    title="클릭 시 상세주소 입력창으로 이동"
                  >
                    <p class="post-number primary-text" title="우편번호">
                      {{ addr.zip }}
                    </p>
                    <p class="list-sub-text">
                      <span class="list-sub-badge">도로명</span>
                      {{ addr.roadAddr1 }}
                    </p>
                    <p class="list-sub-text">
                      <span class="list-sub-badge">지번</span>
                      {{ addr.addr1 }}
                    </p>
                  </a>
                </li>
              </ul>
              <ul class="paging">
                <li>
                  <a
                    @click="pagePrev"
                    v-if="Math.floor((page - 1) / maxPage) !== 0"
                    class="paging-prev"
                    title="이전목록"
                  ></a>
                </li>
                <li
                  v-for="pageNumber in displayedPages"
                  v-bind:key="pageNumber"
                >
                  <a
                    @click="page = pageNumber"
                    title="페이지 번호"
                    :class="{ current: page === pageNumber }"
                    >{{ pageNumber }}</a
                  >
                </li>
                <li>
                  <a
                    @click="pageNext"
                    v-if="
                      Math.floor((page - 1) / maxPage) !==
                        Math.floor((pages.length - 1) / maxPage)
                    "
                    class="paging-next"
                    title="다음목록"
                  ></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="section">
          <div class="section-header blind">
            <h3>
              선택한 주소의 도로명주소, 지번주소를 확인하고 상세 주소를 입력
            </h3>
          </div>
          <div class="section-body">
            <div class="field-group">
              <div class="field-label">
                <label for="find-address-basic">기본주소</label>
              </div>
              <div class="field-control">
                <div class="field-control-sub">
                  <input
                    v-model="addr.roadAddr1"
                    id="find-address-basic"
                    type="text"
                    class="input-text-disabled input-font wfull"
                    readonly
                    title="검색결과에서 선택한 도로명 주소"
                  />
                </div>
              </div>
            </div>
            <div class="field-group">
              <div class="field-label">
                <label for="find-address-detail">상세주소</label>
              </div>
              <div class="field-control">
                <div class="field-control-sub">
                  <input
                    v-model="addr.addrDetail"
                    ref="findAddressDetail"
                    id="find-address-detail"
                    type="text"
                    @input="onlyText"
                    name="addrDetail"
                    class="input-text input-font wfull"
                    title="나머지주소를 입력"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dialog__footer">
        <button @click="closeDialog" type="button" class="normal-button">
          취소
        </button>
        <button @click="submit" type="button" class="primary-button">
          확인
        </button>
      </div>
    </div>
    <v-dialog />
  </modal>
</template>

<script>
import { searchAddr } from '@/api/common'

export default {
  name: 'ZipcodeDirectPopup',
  data() {
    return {
      addr: {},
      inAddr: '',
      addrList: [],
      page: 1,
      perPage: 5,
      maxPage: 5,
      pages: []
    }
  },
  props: {
    close: Function
  },

  watch: {
    addrList() {
      this.setPages()
    }
  },

  computed: {
    displayedAddrList() {
      return this.paginate(this.addrList)
    },
    displayedPages() {
      let page = this.page - 1
      let pageIndex = Math.floor(page / this.maxPage)

      return this.pages.slice(
        pageIndex * this.maxPage,
        (pageIndex + 1) * this.maxPage
      )
    }
  },

  created() {
    // document.documentElement.style.overflow = 'hidden'
  },

  methods: {
    /** 
     * Function    : onlyText
     * Description : input값 텍스트 체크
     **/
    onlyText(e) {
      if(e.target.name === 'inAddr') this.inAddr = e.target.value.replace(/[^ㄱ-ㅎ가-힣a-zA-Z0-9_@*/+.-\s]/gi, '')
      if(e.target.name === 'addrDetail') this.addr.addrDetail = e.target.value.replace(/[^ㄱ-ㅎ가-힣a-zA-Z0-9_@*/+.-\s]/gi, '')
    },
    
    /** 
     * Function    : searchAddress
     * Description : 주소 리스트 조회
     **/
    searchAddress() {
      searchAddr(this.inAddr)
        .then(res => {
          this.addrList = res.data
        })
        .catch(e => {
          //console.error(e)
        })
    },

    /** 
     * Function    : setPages
     * Description : 전체 페이지수 설정
     **/
    setPages() {
      this.pages = []
      let numberOfPages = Math.ceil(this.addrList.length / this.perPage)
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index)
      }
    },

    /** 
     * Function    : paginate
     * Description : 페이지 번호
     **/
    paginate(list) {
      let page = this.page
      let perPage = this.perPage
      let from = page * perPage - perPage
      let to = page * perPage
      return list.slice(from, to)
    },

    /** 
     * Function    : pagePrev
     * Description : 페이징 이전 페이지로 이동
     **/
    pagePrev() {
      let page = this.page - 1
      let pageIndex = Math.floor(page / this.maxPage)
      this.page = (pageIndex - 1) * this.maxPage + this.maxPage
      return this.page
    },

    /** 
     * Function    : pageNext
     * Description : 페이징 이후 페이지로 이동
     **/
    pageNext() {
      let page = this.page - 1
      let pageIndex = Math.floor(page / this.maxPage)
      this.page = (pageIndex + 1) * this.maxPage + 1
      return this.page
    },

    /** 
     * Function    : closeDialog
     * Description : Dialog 닫기
     **/
    closeDialog() {
      // document.documentElement.style.overflow = 'auto'
      this.$modal.hide('zipcodeAddress')
    },

    /** 
     * Function    : beforeClose
     * Description : Dialog 닫아질때, 값 초기화
     **/
    beforeClose() {
      // document.documentElement.style.overflow = 'auto'
      this.inAddr = ''
      this.addrList = []
      this.page = 1
      this.pages = []
      this.addr = {}
    },

    /** 
     * Function    : selectAddr
     * Description : 주소 선택시 상세주소 입력으로 focus
     **/
    selectAddr(addr) {
      this.$refs.findAddressDetail.focus()
      this.addr = addr
      this.addr.addrDetail = ''
    },

    /** 
     * Function    : validation
     * Description : 필수값 validation
     **/
    validation() {
      let title = '온라인 가입신청 안내'
      if (!this.addr.zip) {
        this.openAlert(title, '주소를 선택해주세요.')
        return false
      }
      if (!this.addr.roadAddr1) {
        this.openAlert(title, '주소를 선택해주세요.')
        return false
      }
      if (!this.addr.addrDetail) {
        this.openAlert(title, '상세주소를 입력해주세요.')
        return false
      }
      return true
    },

    /** 
     * Function    : submit
     * Description : 확인 클릭 시 이벤트 함수
     **/
    submit() {
      if (!this.validation()) return
      // 팝업에서 데이터 넘겨주는 처리
      this.$emit('close', {
        id: 'ok',
        ok: this.addr,
        type: this.$store.state.zipType
      })
      this.closeDialog()
    },

    /** 
     * Function    : openAlert
     * Description : 기본 alert 호출 함수
     **/
    openAlert(title, message) {
      this.$modal.show('dialog', {
        title: title,
        text: message,
        buttons: [
          {
            title: '확인',
            class: 'primary-button'
          }
        ]
      })
    }
  }
}
</script>

<style scoped></style>
